import Enumerable from "linq";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { DRCXAvailableObjects } from "../../common/models/drcx/DRCXAvailableObjects";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IFormTemplate } from "../../services/custom-forms-data-service/TemplateModels";
import i18n from "../../services/localization-service/i18n";
import { FormFeatureEnum, FormTypeEnum, IFormInstanceData } from "../../views/object-form-view/Models";
import { GroupedVirtualizedListItem } from "../grouped-virtualized-list/GroupedVirtualizedList";


export const ALL_FORM_TEMPLATES_ID = 0;


export type FormInstanceItem = {
    model: IFormTemplate | undefined;
    nodata?: boolean;
} & IFormInstanceData & GroupedVirtualizedListItem


const allFormTemplates: IFormTemplate = {
    id: ALL_FORM_TEMPLATES_ID,
    version: 1,
    name: i18n.t('forms.allTemplates'),
    formType: FormTypeEnum.Default,
    formFeatures: FormFeatureEnum.allowClose,
    createdTimestamp: new Date(),
    createdBy: '',
    objectTypes: [eLynxObjectTypeEnum.None],
    selected: true,
    template: {
        title: '',
        controls:[]
    },
    nextInstanceID: 0
};

const noDataFormItem: FormInstanceItem = {
    groupKey: 0,
    model: undefined,
    id: undefined,
    formID: undefined,
    nodata: true,
    templateID: 0,
    objectType: eLynxObjectTypeEnum.None,
    objectID: 0,
    formType: FormTypeEnum.Default,
    formFeatures: FormFeatureEnum.allowClose,
    openedTimestamp: new Date(),
    openedBy: '',
    closedTimestamp: undefined,
    closedBy: undefined,
    history: [],
    attachments: []
};


const CustomFormInstanceListUtils = {

    getFormTemplates: function(templates: IFormTemplate[]): IFormTemplate[] {
        return [allFormTemplates, ...templates];
    }, 
    getInstanceItems: function(data: IFormInstanceData[] | undefined,
        templates: IFormTemplate[] | undefined,
        filteredTemplates: IFormTemplate[]) {

        const instanceItems = data && templates && templates.length ? 
        Enumerable.from(data)
            .select(o => {
            const template = templates?.find(v => v.id === o.templateID);
            return {...o,
                model: template,
            } as FormInstanceItem;
        }).toArray() : [];

        instanceItems.forEach(o => o.groupKey = !o.closedTimestamp ? 0 : 1);


        if (!instanceItems.find(o => o.groupKey === 0)) {

            instanceItems.unshift(noDataFormItem)
        }

        if (!instanceItems.find(o => o.groupKey === 1)) {
            instanceItems.push({...noDataFormItem,
                groupKey: 1,
                closedTimestamp: new Date()
            });
        }

        return Enumerable.from(instanceItems)
                .where(o => o.closedTimestamp === undefined)
                .orderByDescending(o => o.openedTimestamp.valueOf())
                .union(Enumerable.from(instanceItems)
                        .where(o => o.closedTimestamp !== undefined)
                        .orderByDescending(o => o.openedTimestamp.valueOf()).toArray())
                .join(filteredTemplates,
                    o => o.templateID,
                    v => v.id,
                    (o, v) => o)
                .toArray();

    },
    filterAvailableObjects: function(template: IFormTemplate, availableObjects: DRCXAvailableObjects): IeLynxObject[] {

        const allObjects = availableObjects.devices
                            .concat(availableObjects.tanks)
                            .concat(availableObjects.wells)
                            .concat(availableObjects.tankBatteries);

        return template.objectTypes.reduce((result: IeLynxObject[], currentValue) => { 
            return result.concat(allObjects.filter(o => o.objectType === currentValue).map(v => {
                return {
                    id: v.id,
                    objectType: currentValue,
                    objectName: v.displayText,
                    displayText: v.displayText,
                } as IeLynxObject
            }))
        }, []);

    }
    
    
};

export default CustomFormInstanceListUtils;